<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <div v-if="$localStorageService.can('Cat_Tx_busqueda')" class="d-flex justify-content-center w-100 mt-4">
      <div class="barras d-flex mt-4" style="width: 50%; margin-top: 10px;" >
        <b-form-input class="input-filter" v-model="filter" placeholder="Búsqueda por ID o nombre del tratamiento" type="text">
        </b-form-input>
        <b-button class="btn-extra-small" variant="info">
          <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;"></em></span>
        </b-button>
      </div>
    </div>
    
      <div class="col-12 mt-5">
        <br>
        <b-row class="contenedorTablaSinColor">
          <b-col sm="12" md="12" lg="12">
            <b-table
                :fields="!registrosActivos ? fieldsTratamientosCatalogoInactivos : fieldsTratamientosCatalogo"
                :items="tratamientosArray"
                :per-page="perPage"
                :current-page="currentPage"
                responsive
                thead-tr-class="columnasTablaSinColor"
                caption-top
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                v-bind="tratamientosArray"
            >
              <template v-slot:cell(fechaAlta)="row">
                {{ row.item.fechaAlta | formatoFechaCorta }}
              </template>
              <template v-slot:cell(fechaModificacion)="row">
                {{ row.item.fechaModificacion | formatoFechaCorta }}
              </template>
              <template v-slot:cell(enPromocion)="row" v-if="!registrosActivos">
              
                <div style="display: flex;align-items: center;justify-content: center;">
                  <p
                      v-if="
              row.item.enPromocion &&
              $localStorageService.can('Cat_Tx_inactivar')
            "
                      @click="
              actualizarTrt(row.item.idTratamiento, registrosActivos, row.item, false, 2)
            "
                  >
                    <b-form-checkbox
                        switch
                        name="check-button"
                        v-model="row.item.enPromocion"
                        disabled
                    >
                    </b-form-checkbox>
                  </p>
                  <p
                      v-if="
              !row.item.enPromocion &&
              $localStorageService.can('Cat_Tx_activar')
            "
                      @click="
              actualizarTrt(row.item.idTratamiento, registrosActivos, row.item, true, 2)
            "
                  >
                    <b-form-checkbox
                        switch
                        name="check-button"
                        v-model="row.item.enPromocion"
                        disabled
                    >
                    </b-form-checkbox>
                  </p>
                </div>
              </template>
              <template v-slot:cell(acciones)="row" >
                <div style="width: 116%">
                <b-button variant="outline-warning" class="boton-inv mt-1" style="margin-left: 1%" v-if="(opcionSeleccionada == 0) && $localStorageService.can('Cat_Tx_editar')" v-b-tooltip.hover.right title="Editar"> 
                   
                  <router-link :to="{name: 'tratamiento', params: { id: row.item.idTratamiento },}">
                    <em class="editar_svg_amarillo icon-boton"></em>
                  </router-link>
                </b-button>
                <b-button variant="outline-warning" class="boton-inv mt-1" style="margin-left: 1%" v-if="(opcionSeleccionada == 2) && $localStorageService.can('Tx_edittar_inactivo')" v-b-tooltip.hover.right title="Editar">
                  <router-link :to="{name: 'tratamiento', params: { id: row.item.idTratamiento },}">
                    <em class="editar_svg_amarillo icon-boton"></em>
                  </router-link>
                </b-button>


                <b-button variant="outline-danger" class="boton-inv mt-1"
                style="margin-left: 1%"
                              v-if="opcionSeleccionada == 0 && $localStorageService.can('Cat_Tx_inactivar')"
                              v-b-tooltip.hover.right
                              title="Inactivar tratamiento"
                              @click="cambiarRegistroActivo(row.item.idTratamiento, false, row.item)">
                      <em class="tratamiento_outline_red icon-boton"></em>
                </b-button>
               
                <b-button variant="outline-secondary" class="boton-inv mt-1" 
                style="margin-left: 1%; border-color: #108f2c;"
                
                v-if="opcionSeleccionada == 2 && $localStorageService.can('Cat_Tx_activar')"
                              v-b-tooltip.hover.right
                              title="Activar tratamiento"
                              
                              @click="cambiarRegistroActivo(row.item.idTratamiento, true, row.item)">
                      <em class="tratamiento_outline_green icon-boton"></em>
                    </b-button>

                <b-button variant="outline-info" class="boton-inv mt-1" style="margin-left: 1%"
                          v-if="(opcionSeleccionada === 0 | opcionSeleccionada === 2) && $localStorageService.can('Tx_argumentario')" v-b-tooltip.hover.right title="Argumentario">

                  <router-link :to="{name: 'argumentario', params: { id: row.item.idTratamiento, tratamiento: row.item.nombre },}">
                    <em class="starCircle2 icon-boton"></em>
                  </router-link>
                </b-button>

                </div>
              </template>
          </b-table>
            <div align="center" v-if="loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-else>
              <b-alert v-if="tratamientosArray.length === 0" variant="info" show>No se encontraron datos para esta categoría</b-alert>
            </b-col>
            
          </b-col>
        </b-row>
        <b-pagination
          class="mt-4"
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
        ></b-pagination>
      </div>
  
    <b-modal
        v-model="blnModalAltaTramiento"
        size="xl"
        class="redondeo"
        centered
        :no-close-on-backdrop="true"
        hide-footer>
      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class="icono cita_svg" style="filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%); height: 30px"></em>
          <div class="headerTxt mLeft">Alta de nuevo Tratamiento</div>
        </div>
      </template>
      <altaTratamiento @cerrarModal="blnModalAltaTramiento = $event"></altaTratamiento>
    </b-modal>


    <b-modal ref="my-modal"
             id="my-modal"
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             :title="tratamientoInactivar.tratamiento"
             size="lg">
      <div>
        <planes-tratamiento
            :tratamientoInactivar="tratamientoInactivar"
            @registroInactivo="registroInactivo"
        />
      </div>
    </b-modal>



  </div>
</template>

<script>
import miniToastr from "mini-toastr"; //ES6
import altaTratamiento from "@/components/tratamientos_combos/altaTratamiento";
import PlanesTratamiento from "./PlanesTratamiento";

export default {
  name: "listaTratamientos",
  props: {
    msg: String,
    tabCategoria: Number,
    opcionSeleccionada: Number
  },
  components: {
    altaTratamiento,
    PlanesTratamiento
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    registrosActivos: true,
    isBusy: false,
    especialidadArray: [],
    especialidadArrayCrear: [],
    idEspecialidad: 0,
    tratamientosArray: [],
    fieldsTratamientosCatalogoInactivos: [
    {
        key: "idSku",
        label: "ID sku",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "idTratamiento",
        label: "ID tratamiento",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "nombre",
        label: "Nombre sku",
        sortable: false,
      },
      {
        key: "usuarioAlta",
        label: "Usuario alta",
        sortable: false,
      },
      {
        key: "fechaAlta",
        label: "Fecha alta",
        sortable: false,
      },
      {
        key: "usuarioModificacion",
        label: "Usuario modificación",
        sortable: false,
      },
      {
        key: "fechaModificacion",
        label: "Fecha modificación",
        sortable: false,
      },
      {
        key: "enPromocion",
        label: "en promoción",
        sortable: true,
      },
      {
        key: "acciones",
        label: "Acciones",
      },
    ],
    fieldsTratamientosCatalogo: [
      {
        key: "idSku",
        label: "ID sku",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "idTratamiento",
        label: "ID tratamiento",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "nombre",
        label: "Nombre sku",
        sortable: false,
      },
      {
        key: "usuarioAlta",
        label: "Usuario alta",
        sortable: false,
      },
      {
        key: "fechaAlta",
        label: "Fecha alta",
        sortable: false,
      },
      {
        key: "usuarioModificacion",
        label: "Usuario modificación",
        sortable: false,
      },
      {
        key: "fechaModificacion",
        label: "Fecha modificación",
        sortable: false,
      },
      {
        key: "acciones",
        label: "Acciones",
      },
    ],
    fieldsTratamientos: [
      { key: "ID", label: "ID", sortable: true, sortDirection: "desc" },
      {
        key: "Tratamiento",
        label: "Tratamiento",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "Especialidades",
        label: "Perfil laboral",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "especialidadOrigen",
        label: "Especialidad origen",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "editar",
        label: "Acciones",
      },
      /*  {
        key: "Sesiones",
        label: "Sesiones",
        sortable: true,
        sortDirection: "desc",
      }, */
      {
        key: "enPromocion",
        label: "en promoción",
        sortable: true,
      },
      {
        key: "boolDos",
        label: "Estatus",
        sortable: true,
      },
      {
        key: "editar",
        label: "Acciones",
      },
      /* {
        key: "nombreUsuarioModificacion",
        label: "Usuario Modificacion",
        sortable: true,
      }, */
      /* {
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      }, */
    ],
    currentPage: 1,
    perPage: 10,
    filter: null,
    filterOn: [],
    totalRows: null,
    showModalTratamiento: false,
    itemTratamiento: {},
    loading: false,
    blnModalAltaTramiento: false,
    tratamientoInactivar: {
      idTratamiento: null,
      tratamiento: "",
    },
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarEspecialidades();
    /* this.obtenerTratamientos(0); */
      this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
  },
  watch: {
    tabCategoria: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.obtenerCatalogo(newValue, this.opcionSeleccionada);
        }
      }
    },
    opcionSeleccionada: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.obtenerCatalogo(this.tabCategoria, newValue);
        }
      }
    }
  },
  methods: {
   
    registroInactivo(idTratamiento){
      this.tratamientosArray.forEach(f => {
        if (f.ID === idTratamiento ){
          f.registroInactivo = false;
          f.enPromocion = true;
          location.reload();
        }
      })
    },
    abrirModal(tratamiento) {
      this.showModalTratamiento = true;
      this.itemTratamiento = tratamiento;
    },

    cambiarRegistroActivo(idTratamiento, registroActivo, tratamiento){
      var title = "";
      var textButton = "";
      textButton = registroActivo == true ? "activar" : "inactivar";
      title = "¿Estás seguro de " + textButton + " el tratamiento?";

      this.$swal.fire({
        title: title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const params = {
            idTratamiento: idTratamiento,
            registroBool: registroActivo,
            enviarNotificacion: false
          }
          this.$http
            .put(
              this.$api +
                "tratamientos/actualizarTratamiento",
                params
            )
            .then((response) => {
              if (response.data.data == 0) {
                this.$swal({
                  icon: "success",
                  title: "Se actualizó correctamente",
                  showConfirmButton: false,
                  timer: 1500,
                });
                var message1 = response.data.message
                    ? response.data.message
                    : "Se actualizó correctamente el registro";
                miniToastr.success(message1);
                this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
              }else if(response.data.data == 1) {
                this.$swal({
                  icon: "success",
                  title: "Se actualizó correctamente",
                  showConfirmButton: false,
                  timer: 2500,
                });
                var message2 = response.data.message
                    ? response.data.message
                    : "Se actualizó correctamente el registro";
                miniToastr.success(message2);
                this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
              } else if (response.data.data == 2){
                this.$swal({
                  icon: "warning",
                  title: "Desactivar tratamiento",
                  text : response.data.message,
                  confirmButtonText: 'Si',
                  cancelButtonText: 'No',
                  showCancelButton: true,
                  showConfirmButton: true,
                }).then((aceptar) => {
                  if (aceptar.value){
                    const envio = {
                      idTratamiento: idTratamiento
                    }
                    this.$http
                        .post(this.$api +    "tratamientos/inactivar/kit-tratamiento",  envio    )
                        .then((response) => {
                          console.log(response)
                          this.$swal({
                            icon: "success",
                            title: "Se actualizó correctamente",
                            showConfirmButton: false,
                            timer: 2500,
                          });
                          this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
                        })
                  }
                });
              }

            })
            .catch((error) => {
       
              var message = error.response.data.message
                ? error.response.data.message
                : "Error al actualizar el tratamiento";

              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
                showCancelButton: true,
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonText: "Cancelar",
                confirmButtonText: "Ver planes",
                confirmButtonColor: "#0e6ba9",
            }).then(() => {
              this.tratamientoInactivar.tratamiento = tratamiento.nombre;
              this.tratamientoInactivar.idTratamiento = idTratamiento;
              this.$refs['my-modal'].show()

            });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
     
      
    },

    actualizarTrt(id, value, elemento, enPromocion, columna) {
      var title = "";
      var textButton = "";
      var enviarNotificacion = true;
      /* 1 activar inactivar tratamiento */
      /* 2 en prompocion */
      if (columna == 1) {
        textButton = value == true ? "activar" : "inactivar";
        title = "¿Estás seguro de " + textButton + " el tratamiento?";
      } else {
        enviarNotificacion = false;
        textButton = enPromocion == true ? "activar" : "inactivar";
        title =
          "¿Estás seguro de " + textButton + " el tratamiento como promoción?";
      }

      this.$swal.fire({
        title: title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          elemento.boolDos = value == true ? "ACTIVO" : "INACTIVO";
          elemento.bool = value;

          value == true ? "activar" : "inactivar";

          elemento.enPromocion = value == true ? false : enPromocion;

          const params = {
            idTratamiento: id,
            registroBool: value,
            enPromocion: enPromocion,
            enviarNotificacion: enviarNotificacion
          }
          this.$http
            .put(
              this.$api +
                "tratamientos/actualizarTratamiento",
                params
            )
            .then((response) => {
              if (response.data.data == 1) {
                this.$swal({
                  icon: "success",
                  title: "Se actualizó correctamente",
                  showConfirmButton: false,
                  timer: 2500,
                });
                var message = response.data.message
                    ? response.data.message
                    : "Se actualizó correctamente el registro";
                miniToastr.success(message);
                this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
              } else if (response.data.data == 2){
                this.$swal({
                  icon: "warning",
                  title: "Desactivar tratamiento",
                  text : response.data.message,
                  confirmButtonText: 'Si',
                  cancelButtonText: 'No',
                  showCancelButton: true,
                  showConfirmButton: true,
                }).then((aceptar) => {
                  if (aceptar.value){
                    const envio = {
                      idTratamiento: id
                    }
                    this.$http
                        .post(this.$api +    "tratamientos/inactivar/kit-tratamiento",  envio    )
                        .then((response) => {
                          console.log(response)
                          this.$swal({
                            icon: "success",
                            title: "Se actualizó correctamente",
                            showConfirmButton: false,
                            timer: 2500,
                          });
                          this.obtenerCatalogo(this.tabCategoria, this.opcionSeleccionada);
                        })
                  }
                });
              }

            })
            .catch((error) => {
              /* 1 activar inactivar tratamiento */
              /* 2 en prompocion */
              if (columna == 1) {
                elemento.bool = !value;
                elemento.boolDos =
                  elemento.bool == true ? "ACTIVO" : "INACTIVO";
              } else {
                elemento.enPromocion = !enPromocion;
              }
              var message = error.response.data.message
                ? error.response.data.message
                : "Error al actualizar el tratamiento";

              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
                showCancelButton: true,
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonText: "Cancelar",
                confirmButtonText: "Ver planes",
                confirmButtonColor: "#0e6ba9",
            }).then(() => {
                this.tratamientoInactivar.tratamiento = elemento.Tratamiento;
                this.tratamientoInactivar.idTratamiento = elemento.ID;
                this.$refs['my-modal'].show()

            });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    onFiltered(filteredItems) {
      this.loading = true;
      this.totalRows = filteredItems.length;
      setTimeout(() => (this.loading = false), 3000);
      this.currentPage = 1;
    },

    obtenerCatalogo(idCategoria, opcionSeleccionada){
      this.loading = true;
      const parametros = {
        idCategoriaNuevo: opcionSeleccionada == 0 ? idCategoria : 0,
        tratamientosActivos: opcionSeleccionada == 0 ? true : false
      };
      this.registrosActivos = parametros.tratamientosActivos;
      this.$http
        .post(
          this.$api +
            "tratamientos/obtenerCatalogo", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.tratamientosArray = response.data.data;
            this.totalRows = this.tratamientosArray.length;
          }
        }).catch((error) => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo al consultar los tratamientos, por favor intentalo más tarde",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    obtenerTratamientos(id) {
      this.loading = true;
      const parametros = {idEspecialidad: id, bandera: false}
      this.$http
        .post(
          this.$api +
            "tratamientos/obtenerTratamientos", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.tratamientosArray = response.data.data
              .map((it) => {
                return {
                  ID: it.idTratamiento,
                  Tratamiento: it.nombre,
                  Especialidades: it.especialidades,
                  Sesiones: it.minimoSessiones + " / " + it.maximoSesiones,
                  bool: it.registroActivo,
                  boolDos: it.registroActivo == true ? "ACTIVO" : "INACTIVO",
                  editar: "editar",
                  especialidadOrigen: it.especialidadOrigen,
                  enPromocion: it.enPromocion,
                  nombreUsuarioModificacion: it.nombreUsuarioModificacion,
                  fechaModificacion: it.fechaModificacion,
                  nombreCategoria: it.nombreCategoria,
                  descripcion: it.descripcion,
                  nombreEstatus: it.nombreEstatus,

                };
              })
              .filter(function (item) {
                return item.ID != 0;
              });
            this.totalRows = this.tratamientosArray.length;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    llenarEspecialidades() {
      this.$http
        .get(this.$api + "catalogos/obtenerEspecialidades")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.id,
                text: it.especialidad,
                color: it.color,
              };
            });
            this.especialidadArray = arrayRespuesta.filter(function (item) {
              return item.value != 0;
            });

            this.especialidadArrayCrear = arrayRespuesta.filter(function (
              item
            ) {
              return item.value != 0;
            });

            this.especialidadArray.push({ value: 0, text: "TODAS" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  
};
</script>

<style scoped>
.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #c2e7ff;
    background: #ffffff;
    margin-top: 20px;
   /*  margin-right: 3%;*/
    margin-left: 4%;
    padding-right: 2%;
    padding-left: 1%;
    border-radius: 20px;
    text-align: left;
    align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}

.icon-boton {
        margin: auto;
        height: 15px;
        display: block;
        padding: 1px;
    }

    .boton-inv, .boton-inv:hover {
        margin-top: -10px;
        border-radius: 50rem;
        color:  var(--color-icono);
        background-color: white;
        border-color: #F19E14;
        filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
        padding: 5px;
    }

    .boton-inv:hover, .boton-inv:active {
        border-color: var(--color-icono);
    }

</style>
